import { render, staticRenderFns } from "./OpenInList.vue?vue&type=template&id=68f39e44&"
import script from "./OpenInList.vue?vue&type=script&lang=js&"
export * from "./OpenInList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports